import { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const NewsTicker = () => {
  const [ticker, setTicker] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    fetch(`${API_URL}/api/public/ticker`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => setTicker(data))
      .catch(() => {});
  }, []);

  const text = ticker && ticker.enabled ? (ticker.text?.[language] || ticker.text?.ca || '') : '';
  const visible = !!text.trim();

  useEffect(() => {
    if (!visible) return;
    document.body.style.paddingBottom = '40px';
    return () => {
      document.body.style.paddingBottom = '';
    };
  }, [visible]);

  if (!visible) return null;

  const item = (
    <span className="inline-flex items-center px-8 whitespace-nowrap">
      <span className="w-2 h-2 rounded-full bg-[#C5A253] mr-3 shrink-0" />
      {text}
    </span>
  );

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[70] bg-[#1A4D2E] text-white text-sm border-t border-[#C5A253]/40 overflow-hidden"
      role="status"
      data-testid="news-ticker"
    >
      <div className="news-ticker-track flex w-max py-2">
        {item}
        {item}
        {item}
        {item}
      </div>
    </div>
  );
};

export default NewsTicker;
